import { LsqUnsupportedBrowserModalComponent } from '../components/modals/unsupported-browser.modal.component';
import { Modal } from '../models/common';

export class UnsupportedBrowserModal extends Modal {
    public id = 'lsq-unsupported-browser-modal';
    public title = 'The browser you are using is not officially supported';
    public bodyComponent = LsqUnsupportedBrowserModalComponent;
    public width = '58.7rem';
    public showCancelButton = false;
    public showOkButton = true;
    public showFooter = true;
    public okButtonText = 'Ok';
}
